import component from './AccountPage.vue'
export default component
